module.exports = __webpack_public_path__ + "static/media/happy.25465b2d.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/happy.png
 ** module id = 88
 ** module chunks = 0
 **/